function BroccoliCookieLaw()
{
	// const duration = 300;
	const delay = 500;

	// private vars init at init()
	var $bcl;
	var $part_advice;
	var $part_info;
	var $bt_advice_accept_all;
	var $bt_advice_reject_all;
	var $bt_advice_info;
	var $bt_info_accept_selection;
	var $bt_info_accept_essentials;
	var $bt_info_accept_all;
	var $bt_info_cancel;
	var $cookie_section_checkboxes;
	var $part_info_tabs;
	var cookie_name;
	var cookie_path;
	var cookie_expire_time;
	var cookie_sections;

	// private vars used as variables
	var $placeholder;
	var bcl_height;

	// Public functions:
	// Just private funcions made public.
	// They should be called after init only.

	this.init = init;
	this.showBanner = showBanner;
	this.showBannerConfig = showBannerConfig;
	this.hideBanner = hideBanner;


	// Private functions:
	// They should be called after init only.

	function init() {

		// Set privte vars (actually used as constants)
		setPrivateVars();

		// Declare events
		declareEvents();

		// Activate tabs
		activateInfoPartTabs();

		// Load authorized scripts
		activateNewSectionScripts([], getTheCookieSectionNames());

		// Show the banner with delay if cookie is not set
		setTimeout( function() {
            console.log(getTheCookieValue())
			if(getTheCookieValue() == '') {
				showBanner();
			}
		}, delay);

	}

	function setPrivateVars() {
		$bcl = $('#broccoli_cookie_law');
		$part_advice = $bcl.find('.part-advice');
		$part_info = $bcl.find('.part-info');
		$bt_advice_accept_all = $bcl.find('.bt-advice-accept-all');
		$bt_advice_reject_all = $bcl.find('.bt-advice-reject-all');
		$bt_advice_info = $bcl.find('.bt-advice-info');
		$bt_info_accept_selection = $bcl.find('.bt-info-accept-selection');
		$bt_info_accept_essentials = $bcl.find('.bt-info-accept-essentials');
		$bt_info_accept_all = $bcl.find('.bt-info-accept-all');
		$bt_info_cancel = $bcl.find('.bt-info-cancel');
		$cookie_section_checkboxes =
			$bcl.find('.part-info input[type="checkbox"]');
		$part_info_tabs = $bcl.find('.tabs');
		cookie_name = $bcl.data('cookie-name');
		cookie_path = $bcl.data('cookie-path');
		cookie_expire_time = $bcl.data('cookie-expire-time');
		cookie_sections = $bcl.data('cookie-sections'); // jquery parses json
	}

	function declareEvents() {
		$bt_advice_info.click(function() {
			showPartConfig();
			return false;
		});
		$bt_advice_accept_all.click(function() {
			sectionNames = getAllCookieSectionNames();
			applyNewSectionsSelection(sectionNames);
			return false;
		});
		$bt_advice_reject_all.click(function() {
			sectionNames = getEssentialsCookieSectionNames();
			applyNewSectionsSelection(sectionNames);
			return false;
		});
		$bt_info_accept_selection.click(function() {
			sectionNames = getInputCheckedSectionNames();
			applyNewSectionsSelection(sectionNames);
			return false;
		});
		$bt_info_accept_essentials.click(function() {
			sectionNames = getEssentialsCookieSectionNames();
			console.log(sectionNames);
			applyNewSectionsSelection(sectionNames);
			return false;
		});
		$bt_info_accept_all.click(function() {
			sectionNames = getAllCookieSectionNames();
			applyNewSectionsSelection(sectionNames);
			return false;
		});
		$bt_info_cancel.click(function() {
			showPartAdvice();
			return false;
		});
		$(window).on('resize', onResize);
	}

	function activateInfoPartTabs() {
		const $tabs = $part_info_tabs;
		const $tabNav = $tabs.find('.tab-nav');
		$tabs.find('.tab-content').each( function () {
			$tabNav.append($(this).find('.tab-title'));
		});
		$tabs.find('.tab-nav > *').each( function (i) {
			if(i == 0) {
				$(this).addClass('active');
			}
			$(this).on('click', function () {
				$tabs.find('.tab-nav > *').each( function (j) {
					if(i == j) {
						$(this).addClass('active');
					} else {
						$(this).removeClass('active');
					}
				});
				$tabs.find('.tab-content').each( function (j) {
					if(i == j) {
						$(this).show();
					} else {
						$(this).hide();
					}
				});
			});
		});
	}

	function updateInterfaceStateFromTheCookie() {
		// set checkboxes checked or not deppending on the cookie value
		cookieSectionNames = getTheCookieSectionNames();
		$cookie_section_checkboxes.each( function(i) {
			$(this).prop('checked', i == 0 ||
				cookieSectionNames.includes($(this).attr('name')));
		});
	}

	function showBanner(part) {
        if (part === 'config') {
            showPartConfig();
        } else {
            showPartAdvice();
        }
		// $bcl.height(0);
		// $bcl.css('display', 'block');
		// $bcl.animate({ height: bcl_height }, duration);
		// $placeholder.animate({ height: bcl_height }, duration);
		// $(window).resize(onResize)
		createPlaceHolderIfNotExists();
		$bcl.show();
		$placeholder.show();
		onResize();
	}

	function showBannerConfig() {
        showBanner('config');
	}

	function hideBanner() {
		// $bcl.animate({ height: 0 }, duration);
		// $placeholder.animate({ height: 0 }, duration);
		// $(window).resize(onResize)
		$bcl.hide();
		$placeholder.hide();
		onResize();
	}

	function showPartAdvice() {
		$part_advice.show();
		$part_info.hide();
	}

	function showPartConfig() {
		updateInterfaceStateFromTheCookie();
		$part_advice.hide();
		$part_info.show();
	}

	function createPlaceHolderIfNotExists() {
		// The placeholder adds space at bottom to allow showing the footer even
		// if the banner is being shown.
		var placeholderId = 'broccoli-cookie-law-placeholder';
		$placeholder = $('#'+placeholderId);
		if($placeholder.length == 0) {
			$placeholder = $('<div id="'+placeholderId+'"</div>');
			$('body').append($placeholder);
		}
	}

	function getAllCookieSectionNames() {
		return Object.keys(cookie_sections ?? {});
	}
	function getEssentialsCookieSectionNames() {
		return Object.keys(cookie_sections ?? {}).slice(0, 1);
	}

	function getInputCheckedSectionNames() {
		var sections = [];
		$part_info.find('input[type="checkbox"]').each(function() {
			if($(this).is(':checked')) {
				sections.push($(this).attr('name'));
			}
		});
		return sections;
	}

	function getTheCookieSectionNames() {
		var allSectionNames = getAllCookieSectionNames();
		cookieSectionNames = getTheCookieValue().split(',');
		activeSectionNames = [];
		for(i in cookieSectionNames) {
			if(allSectionNames.includes(cookieSectionNames[i])) {
				activeSectionNames.push(cookieSectionNames[i]);
			}
		}
		return activeSectionNames;
	}

	function applyNewSectionsSelection(newSectionNames) {
		var oldSectionNames = getTheCookieSectionNames();
		deleteCookiesNotInSectionsNames(newSectionNames);
		activateNewSectionScripts(oldSectionNames, newSectionNames);
		setTheCookie(newSectionNames);
		hideBanner();
		if(wasSomeSectionDeactivated(oldSectionNames, newSectionNames)) {
			document.location.reload();
		}
	}

	function setTheCookie(sectionNames) {
		var expire = new Date();
		expire.setTime(expire.getTime() + cookie_expire_time * 1000); // convert sec to milisec
		setCookie(cookie_name, sectionNames.join(','), expire.toGMTString());
	}

	function getTheCookieValue() {
		return getCookieValue(cookie_name);
	}

	function onResize() {
		if($placeholder) {
			$placeholder.height($bcl.height());
		}
		// var bcl_height_0 = $bcl.height();
		// console.log($part_advice.height());
		// if(bcl_height_0 > 0) {
		// 	$bcl.css('min-height', $part_advice.height() + 10);
		// } else {
		// 	$bcl.css('min-height', 0);
		// }
	}

	function activateNewSectionScripts(oldSectionNames, newSectionNames) {
		for(i in newSectionNames) {
			if(!oldSectionNames.includes(newSectionNames[i])) {
				eval(cookie_sections[newSectionNames[i]].script);
			}
		}
	}

	function wasSomeSectionDeactivated(oldSectionNames, newSectionNames) {
		for (i in oldSectionNames) {
			if(!newSectionNames.includes(oldSectionNames[i])) {
				return true;
			}
		}
		return false;
	}

	function deleteCookiesNotInSectionsNames(sectionNames) {
		var allCookieNames = getAllStoredCookieNames();
		var authorizedCookieNames =
			getCookieNamesFromSectionNames(sectionNames);
		for(i in allCookieNames) {
			if(!authorizedCookieNames.includes(allCookieNames[i])) {
				deleteCookie(allCookieNames[i]);
			}
		}
	}

	function getCookieValue(name){
		function escape(s) {
			return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1');
		}
    	var match = document.cookie
			.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
        return match ? match[1] : '';
	}

	function setCookie(name, value, expire_time) { // expire_time in ms
		var expire = new Date();
		expire.setTime(expire.getTime() + expire_time);
		document.cookie = name + '=' + value + ';' +
			'path=' + cookie_path + ';' + 'expires=' + expire_time + ';';
	}

	function deleteCookie(name) {
		if(getCookieValue(name)) {
			document.cookie = name + "=" + ";path=" + cookie_path +
				";expires=Thu, 01 Jan 1970 00:00:01 GMT";
		}
	}

	function getAllStoredCookieNames() {
    var cookies = document.cookie.split(/\s*;\s*/);
		var cookieNames = [];
    for(var i in cookies) {
			match = cookies[i].match(/^(.*?)=/);
			if(match) {
				cookieNames.push(match[1]);
			}
    }
    return cookieNames;
	}

	function getCookieNamesFromSectionNames(sectionNames) {
		cookieNames = [];
		for(i in cookie_sections) {
			if(sectionNames.includes(i)) {
				for(j in cookie_sections[i].cookies) {
					cookieNames.push(cookie_sections[i].cookies[j]);
				}
			}
		}
		return cookieNames;
	}

}

// global var, init on jQuery document ready
window.broccoliCookieLaw = new BroccoliCookieLaw();
$( function() {
	broccoliCookieLaw.init();
});
